import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import React from 'react';
import { shape, string, oneOfType, number, bool, oneOf } from 'prop-types';
import { currencyFormatter } from '@magalu/stereo-ui-utils';
import { Content, SrOnlyText } from './installment.styles';

const Installment = _ref => {
  let {
    information,
    isList,
    minimumInstallment,
    format
  } = _ref,
      props = _objectWithoutPropertiesLoose(_ref, ["information", "isList", "minimumInstallment", "format"]);

  const {
    quantity,
    amount,
    paymentMethodDescription,
    totalAmount
  } = information;
  const formattedAmount = currencyFormatter({
    value: amount
  });
  const formattedTotalAmount = currencyFormatter({
    value: totalAmount
  });
  const shouldShowFullFormat = quantity > 1 && !isList;
  const shortFormat = `${quantity}x de ${formattedAmount} ${paymentMethodDescription}`;
  const fullFormat = `${formattedTotalAmount} em ${quantity}x de ${formattedAmount} ${paymentMethodDescription}`;
  const shortFormatAccessible = `${quantity} vez de ${formattedAmount} ${paymentMethodDescription}`;
  const fullFormatAccessible = `${totalAmount} em ${quantity} vezes de ${formattedAmount} ${paymentMethodDescription}`;
  const isFull = format === 'full' || format !== 'short' && shouldShowFullFormat;
  const content = isFull ? fullFormat : shortFormat;
  const contentAcessible = isFull ? fullFormatAccessible : shortFormatAccessible;

  if (minimumInstallment === 0) {
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Content, _extends({
      isList: isList,
      "data-testid": "installment",
      "aria-hidden": "true"
    }, props), content), /*#__PURE__*/React.createElement(SrOnlyText, null, contentAcessible));
  }

  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Content, _extends({
    isList: isList,
    "data-testid": "installment",
    "aria-hidden": "true"
  }, props), fullFormat), /*#__PURE__*/React.createElement(SrOnlyText, null, fullFormatAccessible));
};

process.env.NODE_ENV !== "production" ? Installment.propTypes = {
  information: shape({
    amount: oneOfType([string, number]),
    paymentMethodDescription: string,
    quantity: oneOfType([string, number]),
    totalAmount: oneOfType([string, number])
  }),
  format: oneOf(['short', 'full', null]),
  isList: bool,
  minimumInstallment: number
} : void 0;
Installment.defaultProps = {
  information: {
    amount: '',
    isList: false,
    format: '',
    paymentMethodDescription: '',
    quantity: '',
    totalAmount: ''
  },
  minimumInstallment: 1
};
export default Installment;